import { render, staticRenderFns } from "./tea_reward.vue?vue&type=template&id=f80c0ea8&scoped=true&"
import script from "./tea_reward.vue?vue&type=script&lang=js&"
export * from "./tea_reward.vue?vue&type=script&lang=js&"
import style0 from "./tea_reward.vue?vue&type=style&index=0&id=f80c0ea8&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f80c0ea8",
  null
  
)

export default component.exports